var FAQAutoSuggestionListView, FAQV2AutoSuggestionListView, FaqNoSearchResultsTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

FAQAutoSuggestionListView = require('./autosuggestionlist');

FaqNoSearchResultsTemplate = require('../../no_search_results.html.mustache');

FAQV2AutoSuggestionListView = (function(superClass) {
  extend(FAQV2AutoSuggestionListView, superClass);

  function FAQV2AutoSuggestionListView() {
    return FAQV2AutoSuggestionListView.__super__.constructor.apply(this, arguments);
  }

  FAQV2AutoSuggestionListView.prototype.initialize = function() {
    this.noResultTemplate = FaqNoSearchResultsTemplate;
    return FAQAutoSuggestionListView.prototype.initialize.apply(this, arguments);
  };

  FAQV2AutoSuggestionListView.prototype.renderNoSuggestions = function(keyword, status) {
    this.renderBreadCrumbs(keyword, (I18n.t('js.modules.faq.search_result')) + "'" + keyword + "'");
    return this.toHtml({}, this.noResultTemplate);
  };

  FAQV2AutoSuggestionListView.prototype.renderSuggestions = function(response) {
    var ref;
    if ((response != null ? (ref = response.docs) != null ? ref.length : void 0 : void 0) > 0) {
      this.renderBreadCrumbs(response.query, I18n.t('js.modules.faq.search_result_level'));
      this.toHtml({
        searchQuery: (I18n.t('js.modules.faq.search_result')) + "'" + response.query + "'",
        isV2: true
      });
      return this.renderSuggestionElements(response);
    } else {
      return this.renderNoSuggestions(response.query, 'success');
    }
  };

  return FAQV2AutoSuggestionListView;

})(FAQAutoSuggestionListView);

module.exports = FAQV2AutoSuggestionListView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUva3VtYXJyYS9uYXBpc3RyYW5vL2J1aWxkLzE1MDQ3NzgxNDM1MjYtNzYxNzcvcHJvZHVjdGlvbi0yMDE3LjA5LjA3XzA5LjU0L3N1cHBvcnRfYXBwL21vZHVsZXMvZmFxL2Zyb250ZW5kL3ZpZXdzL3YyX2F1dG9zdWdnZXN0aW9ubGlzdC5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9rdW1hcnJhL25hcGlzdHJhbm8vYnVpbGQvMTUwNDc3ODE0MzUyNi03NjE3Ny9wcm9kdWN0aW9uLTIwMTcuMDkuMDdfMDkuNTQvc3VwcG9ydF9hcHAvbW9kdWxlcy9mYXEvZnJvbnRlbmQvdmlld3MvdjJfYXV0b3N1Z2dlc3Rpb25saXN0LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLGtGQUFBO0VBQUE7OztBQUFBLHlCQUFBLEdBQTRCLE9BQUEsQ0FBUSxzQkFBUjs7QUFDNUIsMEJBQUEsR0FBNkIsT0FBQSxDQUFRLHVDQUFSOztBQUV0Qjs7Ozs7Ozt3Q0FFTCxVQUFBLEdBQVksU0FBQTtJQUNWLElBQUMsQ0FBQSxnQkFBRCxHQUFxQjtXQUNyQix5QkFBeUIsQ0FBQSxTQUFFLENBQUEsVUFBVSxDQUFDLEtBQXRDLENBQTRDLElBQTVDLEVBQWtELFNBQWxEO0VBRlU7O3dDQUlaLG1CQUFBLEdBQXNCLFNBQUMsT0FBRCxFQUFVLE1BQVY7SUFDcEIsSUFBQyxDQUFBLGlCQUFELENBQW1CLE9BQW5CLEVBQThCLENBQUMsSUFBSSxDQUFDLENBQUwsQ0FBTyw4QkFBUCxDQUFELENBQUEsR0FBd0MsR0FBeEMsR0FBMkMsT0FBM0MsR0FBbUQsR0FBakY7V0FDQSxJQUFDLENBQUEsTUFBRCxDQUFRLEVBQVIsRUFBWSxJQUFDLENBQUEsZ0JBQWI7RUFGb0I7O3dDQUl0QixpQkFBQSxHQUFtQixTQUFDLFFBQUQ7QUFDakIsUUFBQTtJQUFBLDJEQUFpQixDQUFFLHlCQUFoQixHQUF5QixDQUE1QjtNQUNFLElBQUMsQ0FBQSxpQkFBRCxDQUFtQixRQUFRLENBQUMsS0FBNUIsRUFBbUMsSUFBSSxDQUFDLENBQUwsQ0FBTyxvQ0FBUCxDQUFuQztNQUNBLElBQUMsQ0FBQSxNQUFELENBQVE7UUFBQyxXQUFBLEVBQWUsQ0FBQyxJQUFJLENBQUMsQ0FBTCxDQUFPLDhCQUFQLENBQUQsQ0FBQSxHQUF3QyxHQUF4QyxHQUEyQyxRQUFRLENBQUMsS0FBcEQsR0FBMEQsR0FBMUU7UUFBOEUsSUFBQSxFQUFNLElBQXBGO09BQVI7YUFDQSxJQUFDLENBQUEsd0JBQUQsQ0FBMEIsUUFBMUIsRUFIRjtLQUFBLE1BQUE7YUFLRSxJQUFDLENBQUEsbUJBQUQsQ0FBcUIsUUFBUSxDQUFDLEtBQTlCLEVBQXFDLFNBQXJDLEVBTEY7O0VBRGlCOzs7O0dBVnNCOztBQWtCM0MsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
